module.exports = __webpack_public_path__ + "黑子.a6130fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/黑子.png
// module id = 116
// module chunks = 2